import { UserDTO } from "./user";
import { JpdDto } from "./jpd";
import { BucketDto, LicenseGroup } from "./licenses";

export enum DeploymentType {
  SAAS = "SAAS",
  SELF_HOSTED = "SELF_HOSTED",
}

export enum DeploymentIdentity {
  ARTIFACTORY = "ARTIFACTORY",
  EDGE = "EDGE",
  ICE = "ICE",
  MIXED = "MIXED",
  COLD = "COLD",
  FLY = "FLY",
}

export interface RegistrationGroupDto {
  registrationGroupNumber: number;
  deploymentType: DeploymentType;
  deploymentIdentity: DeploymentIdentity;
  owner: UserDTO;
  jpds: JpdDto[];
  buckets: BucketDto[];
  licenseGroups: LicenseGroup[];
}
